import localStorage from "../common/localStorageService";
import encryption from "../crypto/encryptionService";

const key = "SHAREDO_SETTINGS";

const get = () => {
    var settings = localStorage.get(key);

    if (settings && settings.clientSecret) {
        settings.clientSecret = encryption.decrypt(settings.clientSecret);
    }

    return settings;
}

const set = settings => {
    const settingsClone = Object.assign({}, settings);

    if (settingsClone.clientSecret) {
        settingsClone.clientSecret = encryption.encrypt(settingsClone.clientSecret)
    }

    localStorage.set(key, settingsClone);
}

const clear = () => localStorage.remove(key);

export default {
    get,
    set,
    clear
}